import React from "react";

function RecentActivity({ fill = "#f1f9f5" }) {
  return (
    <svg
      width="27"
      height="50"
      viewBox="0 0 27 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4459_7297)">
        <g clipPath="url(#clip1_4459_7297)">
          <rect width="26.3704" height="26.3704" rx="13.1852" fill={fill} />
          <rect
            width="26.3704"
            height="26.3704"
            rx="13.1852"
            stroke="#E2E8F0"
          />
        </g>
        <rect
          x="13.1852"
          y="26.3711"
          width="0.824074"
          height="49.4444"
          fill="#E2E8F0"
        />
        <rect
          x="13.1852"
          y="26.3711"
          width="0.824074"
          height="49.4444"
          stroke="#E2E8F0"
        />
      </g>
      <defs>
        <clipPath id="clip0_4459_7297">
          <rect width="26.3704" height="46.4444" fill="white" />
        </clipPath>
        <clipPath id="clip1_4459_7297">
          <rect width="26.3704" height="26.3704" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default RecentActivity;
